const getters = {
    fertilityProducts: state => state.fertilityProducts,
    fertilityProductsLight: state => state.fertilityProductsLight,
  }
  
  export default getters;
  